import React from 'react';
import {useDispatch} from 'react-redux';
import {Box, Stack, Typography} from '@mui/material';
import {ICompanySchool} from '../../dto/CompanySchool.dto';
import {useStylesed} from '../styles/commonStyled';
import {useRqCompanyWithSchools} from '../../react_query/companies/Company';
import {init} from '../../store/Slices/OnboardCmySchoolsSlice';

export const CompanyWithSchools = ({
  company_id,
  isViewOnlyCompany = false,
}: {
  company_id: number;
  isViewOnlyCompany?: boolean;
}) => {
  const {data, isFetched, isError} = useRqCompanyWithSchools(company_id);
  const Company = data;

  const dispatch = useDispatch();
  React.useEffect(() => {
    if (data && isFetched && !isError) {
      dispatch(init(data));
    }
  }, [data, isFetched, isError, dispatch]);

  return (
    <>
      {isFetched ? (
        <>
          <Typography variant='h6'>{Company?.name}</Typography>
          {!isViewOnlyCompany ? (
            <Box mt={1} px={1}>
              {Company?.schools.map((school: ICompanySchool) => {
                return <SchoolsList school={school} key={school.id} />;
              })}
            </Box>
          ) : null}
        </>
      ) : null}
    </>
  );
};

const SchoolsList = ({school}: {school: ICompanySchool}) => {
  const classes = useStylesed();
  return (
    <Box>
      <Stack direction='row' spacing={2} alignItems='center'>
        <input
          style={{pointerEvents: 'none'}}
          type='checkbox'
          className={classes.blue_checkbox}
          name='branding'
          defaultChecked
          disabled
        />
        <Typography variant='h6'>{school.name}</Typography>
      </Stack>

      <Box ml={4}>
        {school.boys_mascot ? (
          <Typography variant='caption'>
            <strong>BOY's MASCOT :-</strong> {school.boys_mascot}
            <br />
          </Typography>
        ) : (
          <></>
        )}
        {school.girls_mascot ? (
          <Typography variant='caption'>
            <strong>GIRL's MASCOT :-</strong> {school.girls_mascot}
          </Typography>
        ) : (
          <></>
        )}
      </Box>
    </Box>
  );
};

export default React.memo(CompanyWithSchools);
